var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 14.4025C47.1496 14.047 44.7799 13.8337 42.4037 13.7638C41.1141 12.4108 39.4157 11.5188 37.5697 11.2249C35.7237 10.931 33.8323 11.2515 32.1862 12.1372C30.5401 13.0229 29.2305 14.4247 28.4586 16.1271C27.6867 17.8295 27.4953 19.7383 27.9137 21.56C20.8438 21.2013 15.4887 17.57 10.4837 12.1713C9.80125 13.5013 8.50625 17.7451 9.5125 20.8076C10.7075 23.8346 12.7602 26.4469 15.4187 28.3238C12.8605 28.2068 10.3402 27.6596 7.96375 26.7051C9.1975 30.7563 13.4325 36.6363 20.0912 37.555C17.0838 39.9309 13.3627 41.2227 9.53 41.2213C8.85203 41.2292 8.17418 41.1971 7.5 41.125C11.3847 43.6354 15.9123 44.9693 20.5375 44.9663C36.1738 44.9663 44.7312 31.9375 44.7312 20.6325V19.5213L49.5 14.4025Z",
    stroke: "#00A79D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c5796b458261dbe1a2f671c1a47ef1ef.svg";
export { ForwardRef as ReactComponent };